import { DetailedHTMLProps, HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Badge.module.scss';

export enum BadgeTheme {
  Primary = 'primary',
  Yellow = 'yellow',
  DarkYellow = 'darkYellow',
  Red = 'red',
  GreenHack = 'greenHack',
}

interface BadgeProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  theme?: BadgeTheme;
}

export const Badge = ({ children, className, theme = BadgeTheme.Primary, ...props }: BadgeProps) => {
  return (
    <div className={classNames(styles.Wrapper, styles[theme], className)} {...props}>
      {children}
    </div>
  );
};
